/** ******** 下载中心  ********* */
// 获取下载中心列表

export const getDownloadCenterList = {
  url: '/admin/importOrExportExcel/getExportRecordList.json',
  method: 'get'
};

// 删除下载记录
export const deleteExportRecord = {
  url: '/admin/importOrExportExcel/deleteExportRecordByRecordId.json',
  method: 'post',
  config: {
    headers: { 'Content-Type': 'multipart/form-data' }
  }
};

// 获取下载地址
export const getDownloadUrl = {
  url: '/admin/importOrExportExcel/getExcelUrlByRecordId.json',
  method: 'post'
};
